import { render, staticRenderFns } from "./OperatorSidebar.vue?vue&type=template&id=1f584b04&scoped=true"
import script from "./OperatorSidebar.vue?vue&type=script&lang=js"
export * from "./OperatorSidebar.vue?vue&type=script&lang=js"
import style0 from "./OperatorSidebar.vue?vue&type=style&index=0&id=1f584b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f584b04",
  null
  
)

export default component.exports